import { CSSProperties } from 'react';
import { borderRadius } from '../../../theme/borderRadius';
import { colors, hexToRgbA } from '../../../theme/colors';
import spacing from '../../../theme/spacing';
import { fontSize } from '../../../theme/typography';

export const accountSettingsCardFieldStyles: CSSProperties = {
  background: hexToRgbA(colors.backgroundLight, 0.8),
  padding: `${spacing.mediumLarge} ${spacing.mediumLarge}`,
  borderRadius: borderRadius.large,
};

export const settingTitleStyles: CSSProperties = {
  color: colors.textPrimary,
  fontSize: fontSize.md,
  fontWeight: '500',
};

export const fieldRowStyles: Record<'row' | 'infoContainer', CSSProperties> = {
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  infoContainer: {
    flex: 1,
    minWidth: 0,
  },
};
